<template>
  <CustomModal ref="modal" title="Ajouter un comptable">
    <p>Afin de permettre à un comptable d'accéder à toutes les informations dont il a besoin, cliquez sur le bouton ci-dessous pour générer un jeton. C’est ensuite à vous de lui faire parvenir ce jeton (par e-mail, par exemple).</p>
    <p>Pour information, le comptable aura accès :</p>
    <ul>
      <li>Aux montants net, brut et de TVA de vos factures.</li>
      <li>Aux numéros de vos factures.</li>
      <li>Aux dates de création de vos factures.</li>
      <li>Aux status de vos factures.</li>
    </ul>
    <div>
      <CustomForm v-if="!inputs.token.value" ref="form" :inputs={} :submit=buttons.submit>
        <CustomButton @click="submitForm" :params=buttons.submit style="margin-top: 15px" />
      </CustomForm>
      <div v-show="inputs.token.value" class="clipboard">
        <CustomTextField :content=inputs.token></CustomTextField>
        <button id="clipboard" class="button-icon-custom button-clipboard">
          <span class="clipboard-tooltip" :class="{ showed : isClipboardTooltip }">Copié !</span>
          <span class="fas fa-paste"></span>
        </button>
      </div>
    </div>
  </CustomModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import {GroupController} from "@/controllers/user/GroupController";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
library.add(faXmark);

  export default {
      name: 'GenerateTokenForLinkAccountantModal',
      props: ['callback'],
      components: {CustomTextField, CustomModal, CustomForm, CustomButton},
      data() {
          return {
            inputs: {
              token: {label: 'Jeton', value: '', type: 'text'}
            },
            buttons:{
              submit: {text: "Générer le jeton"},
            },
            isClipboardTooltip : false
          };
      },
      methods: {
        openModal() {
          this.$refs.modal.openModal();
          this.inputs.token.value = '';

          const self = this;
          //add event listner to elementtrigger
          setTimeout(() => {
            let trigger = document.getElementById("clipboard");
            trigger.addEventListener("click", function () {
              //create the readonly textarea with the text in it and hide it
              let tarea = document.createElement("textarea");
              tarea.setAttribute("id", "clipboard" + "-copyarea");
              tarea.setAttribute("readonly", "readonly");
              tarea.setAttribute("style", "opacity: 0; position: absolute; z-index: -1; top: 0; left: -9999px;");
              tarea.appendChild(document.createTextNode(self.inputs.token.value));
              document.body.appendChild(tarea);

              //select and copy the text in the readonly text area
              tarea.select();
              // TODO Regarder ça
              document.execCommand("copy");

              //remove the element from the DOM
              document.body.removeChild(tarea);

              // Call back
              self.isClipboardTooltip = true;
              setTimeout(() => {
                self.isClipboardTooltip = false;
              }, 3000);

            });
          }, 1000);
        },
        closeModal(event = false) {
          this.$refs.modal?.closeModal(event);
        },
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => GroupController.generateTokenForLinkAccountantToGroup());
          if (!res.errors) {
            this.inputs.token.value = res;
          }
        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';
    .modal
      padding-bottom 40px
      height auto
    .button-container
      display flex
      justify-content center
      padding-top 20px
    .clipboard
      display flex
      .button-clipboard
        margin-top 20px
        margin-left 10px
        .clipboard-tooltip
          position absolute
          visibility hidden
          opacity 0
          margin-top -45px
          margin-left -15px
          box-shadow 0 0 5px 0 rgba(0, 0, 0, 0.3)
          border-radius 5px
          padding 5px
          transition: visibility 0s, opacity 0.3s linear;
          &.showed
            visibility visible
            opacity 1
</style>
